<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="payFreightCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="row.carrierStatementStatus === '已付款' ? 'light' : 'warning'"
        >
          {{ row.carrierStatementStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            v-allow="'actCancelBill'"
            placement="top"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:carrierStatementNo="{row}">
        <div>
          <el-link
            type="primary"
            @click="
              openEditPage({
                pageType: 'detail',
                params: row,
              })
            "
          >
            {{ row.carrierStatementNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableColumns: tableColumns(),
      fullScreenLoading: false,
      waybillCode: '',
      codeList: [],
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 242
    },

    getTableCheckedData({isNotEmpty}) {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (isNotEmpty) {
        if (data === null || data === [] || !data.length) {
          this.$message({
            message: `请选择您要回退的账单！`,
            type: 'warning',
          })
          return false
        }
      }

      if (data.length > 20) {
        this.$message.warning('每次批量提交处理的单据数量，不能超过20张')
        return false
      }

      return data
    },
    batchRollback() {
      const data = this.getTableCheckedData({
        isNotEmpty: true,
        type: 'rollback',
      })
      if (!data) return

      this.codeList = data.map((i) => {
        return i.carrierStatementCode
      })

      this.$confirm('确认要回退账单吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.rollbackSubmit()
      })
    },
    rollback(row) {
      this.codeList = []
      this.codeList.push(row.carrierStatementCode)

      this.$confirm('确认要回退该账单吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.rollbackSubmit()
      })
    },
    rollbackSubmit() {
      this.fullScreenLoading = true
      this.$api
        .finCarrierStatementRollbackTransportModeApi({
          carrierStatementCodeList: this.codeList,
        })
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          // 清除选中的记录
          this.$refs.table.clearCheckboxRow()
          this.$refs.table.clearCheckboxReserve()
          this.$emit('reload')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'finance-charteredPayable-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
